import './upload-medical-certificate-form.scss';
import { useTranslation } from 'react-i18next';
import { Col, FormFeedback, Label, Row } from 'reactstrap';
import { Controller, UseFormReturn } from 'react-hook-form';
import UploadImageInput from '../../../shared/UploadImageInput/UploadImageInput';
import { useUploadMedicalCertificate } from '../../../../store/gym-management/GymHooks';
import { UploadImageTypeEnum } from '../../../../API/file-uploader/enums/upload-image-type.enum';

type PropsTypes = {
  form: UseFormReturn<any, object>;
};

const UploadMedicalCertificateForm = (props: PropsTypes) => {
  const { t } = useTranslation();
  const uploadMedicalCertificate = useUploadMedicalCertificate();

  const {
    control,
    formState: { errors },
  } = props.form;

  return (
    <>
      <Row>
        <Col md="12">
          <div className="upload-medical-certificate-text">
            {t('UPLOAD_MEDICAL_CERTIFICATE_EXPLAIN_TEXT')}
          </div>
        </Col>
        <Col md="12" className="form-user-input">
          <Label for="file">{t('MEDICAL_CERTIFICATE_LABEL')}</Label>
          <Controller
            name="file"
            control={control}
            render={({ field: { onChange, value } }) => (
              <UploadImageInput
                id="file"
                className="text-input"
                placeholder=""
                invalid={errors.file && true}
                uploaderHook={uploadMedicalCertificate}
                //TODO: return after speaking with Yaniv
                // uploadType={UploadImageTypeEnum.USERS_MEDICAL_FORM}
                onChange={onChange}
                value={value}
              />
            )}
          />
          {errors.file ? (
            <FormFeedback className="form-input-error">
              {errors.file.message}
            </FormFeedback>
          ) : null}
        </Col>
      </Row>
    </>
  );
};

export default UploadMedicalCertificateForm;
